var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apply-doc-component',{ref:"applyDocTable"}),_c('exam-check-list-component',{ref:"examCheckTable"}),_c('form-check-component',{on:{"refetchTables":_vm.refetchTables}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }